import React from 'react';
import {OPERANDS_BY_VALUE} from 'constants/FilterConstants';

const OperandShorthand = ({value}) => {
  const operand = OPERANDS_BY_VALUE[value];

  return <span>{operand && operand.shorthand}</span>;
};

export default OperandShorthand;
